export default __webpack_public_path__ + "static/media/US.385dd76d.svg";